import axios from 'axios';
import { SERVER_URL } from '../../../../constants/ClientConfig';
import { USER_STATUS, USER_FORGOT_DETAILS, USER_GET_OTP, USER_VERIFY_OTP, USER_UPDATE_IRCTC_ID,AADHAR_ERROR_FLOW_NULL } from '../../../../constants/ActionTypes';
import {
  setItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';
import { STORAGE_CONSTANTS,IRCTC_TATKAL_AADHAAR_NOT_VERIFIED_ERROR,TRAVELLERS_TRACKING_KEY,AADHAR_ERRORS } from '../../../../constants/TrainConstants';
import { updateIrctcUserName } from '../../../../API/TravellerPage/TravellerPageApi';
import { isUserLoggedIn } from '../../../../utils/BizUtils';
import { generateId } from '../../../../utils/trainUtils';
import { changeUserDetail } from './TravellerActions';
import { trackClickEventProp61 } from '../../../../utils/omnitureTracker';

export const fetchUserStatusAction = (userId) => async (dispatch,getState) => {
  const quota = getState()?.traveller?.railInfo?.selectedQuota ?? null;
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId,quota};
    const res = await axios.get(`${SERVER_URL}/user/status/${userId}`, { headers });
    const userStatus = res.data;
    let aadharErrorFlow = false;
    if(userStatus?.verificationFlow?.errorCode === IRCTC_TATKAL_AADHAAR_NOT_VERIFIED_ERROR)
    {
      aadharErrorFlow=true;
    }
    dispatch({
      type: USER_STATUS,
      payload: { userStatus,aadharErrorFlow },
    });
    if (!res?.data?.error) {
      dispatch({
        type: USER_UPDATE_IRCTC_ID,
        payload: res?.data?.irctcUserId,
      })
      setItemBySession(
        STORAGE_CONSTANTS.VERIFIED_USER_ID,
        userId,
        { isPiiData: true, shouldStringifyJson: true },
        itemType.ES
      );
      if (isUserLoggedIn()) {
        updateIrctcUserName(userId);
      }
    }
  } catch (error) {
    console.error(error);

  }
};

export const fetchUserStatusAPI = async (userId, quota) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId, quota};
    const res = await axios.get(`${SERVER_URL}/user/status/${userId}`, { headers });
    const userStatus = res.data;
    let aadharErrorFlow = false;
    if(userStatus?.verificationFlow?.errorCode === IRCTC_TATKAL_AADHAAR_NOT_VERIFIED_ERROR)
    {
      trackClickEventProp61(TRAVELLERS_TRACKING_KEY,AADHAR_ERRORS);
      aadharErrorFlow = true;
    }
    return { userStatus, aadharErrorFlow };
  } catch (error) {
    console.error(error);
  }
};

export const setUserStatusAction = (userStatus, aadharErrorFlow) => ({
  type: USER_STATUS,
  payload: { userStatus, aadharErrorFlow },
});

export const verifyUserStatus = (userId) => (dispatch, getState) => {
  const quota = getState()?.traveller?.railInfo?.selectedQuota ?? null;
  
  fetchUserStatusAPI(userId, quota)
    .then(({ userStatus, aadharErrorFlow }) => {
      dispatch(setUserStatusAction(userStatus, aadharErrorFlow));
    })
    .catch(error => {
      console.error(error);
    });
};

export const saveNClose = (userStatus) => (dispatch) => {
  if (!userStatus?.error) {
    dispatch(changeUserDetail('verifiedUserId', userStatus?.userId));
    dispatch({
      type: USER_UPDATE_IRCTC_ID,
      payload: userStatus?.userId,
    })
    setItemBySession(
      STORAGE_CONSTANTS.VERIFIED_USER_ID,
      userStatus?.userId,
      { isPiiData: true, shouldStringifyJson: true },
      itemType.ES
    );
    if (isUserLoggedIn()) {
     updateIrctcUserName(userStatus?.userId);
    }
  }
}

export const userForgotDetailsAction = (requestType, queryParams) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    const res = await axios.get(`${SERVER_URL}/user/irctc/details/${requestType}`, {
      params: {
        userLoginId: queryParams.userLoginId || '',
        email: queryParams.email || '',
        mobile: queryParams.mobile || '',
        otpType: queryParams.otpType || '',
        dob: queryParams.dob || '',
      },
    }, { headers });
    const userDetails = res.data;
    dispatch({
      type: USER_FORGOT_DETAILS,
      payload: {
        userDetails: {
          ...userDetails,
          otpType: queryParams.otpType,
          email: queryParams.email,
        }
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const userForgotDetailsActionV2 = (requestType, queryParams) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = { "X-Trace-Id": traceId };
    const requestBody = {
      userLoginId: queryParams.userLoginId || '',
      email: queryParams.email || '',
      mobile: queryParams.mobile || '',
      otpType: queryParams.otpType || '',
      dob: queryParams.dob || '',
    };
    if (queryParams.showResetPasswordConfig) {
      requestBody.showResetPasswordConfig = true;
    }
    const res = await axios.post(
      `${SERVER_URL}/user/irctc/detailsV2/${requestType}`,
      requestBody,
      { headers }
    );
    const userDetails = res.data;
    dispatch({
      type: USER_FORGOT_DETAILS,
      payload: {
        userDetails: {
          ...userDetails,
          otpType: queryParams.otpType,
          email: queryParams.email,
        }
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const onClearingAadharFlow = () => ({
    type: AADHAR_ERROR_FLOW_NULL,
});

export const getOtpAction = (userId, otpType) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    const res = await axios.get(`${SERVER_URL}/user/getOtp/${userId}/${otpType}`, { headers });
    const getOtpResponse = res.data;
    dispatch({
      type: USER_GET_OTP,
      payload: { getOtpResponse },
    });
  } catch (error) {
    console.error(error);
  }
};

export const verifyOtpAction = (userId, otpType, queryParams) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    const res = await axios.get(`${SERVER_URL}/user/verifyOtp/${userId}/${otpType}`, {
      params: {
        emailCode: queryParams.emailCode || '',
        smsCode: queryParams.smsCode || '',
      },
    }, { headers });
    const verifyOtpResponse = res.data;
    dispatch({
      type: USER_VERIFY_OTP,
      payload: { verifyOtpResponse },
    });
  } catch (error) {
    console.error(error);
  }
};
